type ErrorMessageResponse = {
  data?: ErrorResponse & { message?: string }
}

export const getErrorMessages =
  (defaultMessages: string[]) => (response?: ErrorMessageResponse) => {
    const errorMessages = response?.data?.errors || response?.data?.message
    if (Array.isArray(errorMessages)) {
      return errorMessages.join(', ') || defaultMessages.join(', ')
    } else {
      return errorMessages || defaultMessages.join(', ')
    }
  }
